import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { resetLastUpdate, setLastUpdate, setLocation } from 'src/app/redux/actions/options.action';
import { NAVEGATION } from 'src/app/shared/const/navegation';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { PriceString } from 'src/app/shared/interfaces/price.interface';
import { FilterAllPricePipe } from 'src/app/shared/pipes/filter/filter-all-price.pipe';
import { PriceSortPipe } from 'src/app/shared/pipes/sorts/pricesSort.pipe';
import { PriceValidator } from 'src/app/shared/price';
import { MaestrosService } from 'src/app/shared/services/mestros.service';
import { SessionChecker } from 'src/app/shared/session.checker';
import { DataRefreshService } from 'src/app/shared/services/data-refresh.service';
import { TablesIBMClass } from 'src/app/shared/tables-ibm';
import { selectAllPrices } from 'src/app/redux/selectors/prices.selectors';
import { Price } from '@shared-logic/prices';

@Component({
  selector: 'app-price-board',
  templateUrl: './price-board.component.html',
  styleUrls: ['./../../shared/styles/body.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush // Aplica la estrategia OnPush
})

export class PriceBoardComponent extends TablesIBMClass implements OnInit, OnDestroy {
  private prices: Price[] = [];
  private prices$!: Subscription;
  conditionFilters: number[] = [];

  private conditionFilters$!: Subscription;

  constructor(private store: Store<appState>, private checker: SessionChecker, private priceV: PriceValidator,
    maestroSvc: MaestrosService, private dataRefreshService: DataRefreshService, private cdr: ChangeDetectorRef) {
    super(maestroSvc)
    this.loadPrices();

    this.checker.rememberAndActualizateUser(this.store);
    this.store.dispatch(setLocation({ location: NAVEGATION.PRICE_BOARD }));
  }

  setSubscriptions() {
    this.prices$ = this.store.select(selectAllPrices).subscribe((priceAll) => {
      this.prices = priceAll;
      // Trigger change detection when prices update
      this.cdr.markForCheck();
    });

    this.conditionFilters$ = this.store.select('options', 'board', 'conditionFilter').subscribe((conditionFilter) => {
      this.conditionFilters = conditionFilter;
      // Trigger change detection when filters update
      this.cdr.markForCheck();
    });
  }

  setUnsubscriptions() {
    this.prices$?.unsubscribe();
    this.conditionFilters$?.unsubscribe();
  }

  ngOnInit(): void {
    this.setSubscriptions();
  }

  ngOnDestroy(): void {
    this.setUnsubscriptions();
    this.store.dispatch(resetLastUpdate());
  }

  loadPrices() {
    this.dataRefreshService.refreshPrices();
  }
}

export function getPriceListWithPipes(prices: Price[], isComercial: boolean, buyerType: string,
  priceFilter: PriceString, conditionType: string, search: string, conditionFilters: number[]) {
  const pipe = new FilterAllPricePipe();
  return pipe.transform(prices, isComercial, buyerType, priceFilter, conditionType, search, conditionFilters);
}

export function getPriceListWithPipesAndSort(prices: Price[], isComercial: boolean, buyerType: string,
  priceFilter: PriceString, conditionType: string, search: string, conditionFilters: number[]) {
  const pipe4 = new PriceSortPipe();
  return pipe4.transform(getPriceListWithPipes(prices, isComercial, buyerType, priceFilter, conditionType, search, conditionFilters), isComercial);
}